import React from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { useState } from 'react';
import { useEdit } from '../../Services/EditContext';

export const InsertPaths = ({ path, parentPath, insertItem }) => {
    const [expanded, setExpanded] = useState();
    const [edit] = useEdit();
    const newPath = parentPath ? parentPath + '/' + path?.name : path?.name;
    return edit && path ? <Container>


        <Row>  <Col>{path.accessors && path.accessors.length ?
            <Button onClick={() => setExpanded(!expanded)}>{expanded ? '- ' : '+ '} {path.name}</Button> :
            <Button onClick={() => insertItem(newPath)}>Insert {path.name}</Button>}</Col></Row>
        {expanded && path?.accessors?.map((x, i) => <Row key={i}><InsertPaths parentPath={newPath} path={x} insertItem={insertItem} /></Row>)}

    </Container> : null;


};
